import { FETCH_MENU_ITEMS, REFRESH_MENU } from '../actions/types';

const initialState = {
    items: [],
    liveUrl: null,
    previewUrl: null,
    reload: null
};

export default function (state = initialState, action) {
    //console.log(action.payload);
    switch (action.type) {
        case REFRESH_MENU: return { ...state, reload: action.payload };

        case FETCH_MENU_ITEMS: return { ...state, items: action.payload.items, liveUrl: action.payload.liveUrl, previewUrl: action.payload.previewUrl };

        default: return state;
    }
};